<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/south-africa/stellenbosch')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/alto-wine-estate')">Alto Wine Estate</nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/kanonkop-paul-sauer')">Kanonkop Paul Sauer</nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/meerlust-estate')">Meerlust Estate</nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/savanha-wines')">Savanha Wines</nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/the-sadie-family-wines')">The Sadie Family Wines</nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/south-africa/stellenbosch/thelema-mountain-vineyards')">Thelema Mountain Vineyards</nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/south-africa/stellenbosch')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Thelema Mountain Vineyards</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Con l'aumento dei vini del nuovo mondo, molte delle vedove della regione possono essere dimenticate.
                        Perché, ad esempio, dovresti prendere in considerazione un Kanonkop, quando hai un piccolo numero sexy di Eben Sadie
                        ti aspetto a casa? Ma sbaglieresti a ignorare i vecchietti (che, relativamente
                        parlando, sono solo bambini in braccio rispetto ad alcuni dei dinosauri europei). Monte Thelema
                        vigneti, piantati nel 1983, è uno di questi vecchi che non dovrebbe essere lasciato sullo scaffale posteriore.
                    </div>

                    <div class="howto-title2">Dalla calcolatrice ai campi</div>
                    <div class="howto-text">
                        Dopo aver bevuto un Burgundy Puligny-Montrachet nel 1983, Gyles Webb, un contabile di Durban, ebbe un'illuminazione. Si è riqualificato come enologo, ha acquistato un vecchio frutteto decrepito di 157 ettari, ha strappato i frutteti e ha piantato le viti. Il restauro del maniero ha richiesto cinque anni, quindi si è concentrato su quello mentre l'uva stava maturando, e nel 1988 è stato rilasciato il primo vino con l'etichetta Thelema. I vini freschi e fruttati non furono solo i leader del nuovo movimento enologico mondiale, ma anche una rivelazione per molti (incluso in una certa misura lo stesso Webb). Non passò molto tempo prima che la storia romantica di un vecchio frutteto fatiscente diventasse la storia di successo di una moderna azienda vinicola. Alla fine degli anni '90, Thelema era il vino del giorno tra l'élite sudafricana.
                        <br><br>
                        Nonostante Webb fosse considerato una sorta di visionario della vinificazione, nel 2000 ha consegnato le redini
                        di vinificazione al talentuoso Rudi Schultz e passò al ruolo di cantiniere. Nel 2002,
                        Webb ha ampliato la sua attività nella fresca regione costiera di Elgin, dove si trova l'azienda vinicola
                        produce la sua linea di vini Sutherland.
                    </div>

                    <div class="howto-title2">Il Cab Sav re di Stellenbosch</div>
                    <div class="howto-text">
                        Con tutti i vini del nuovo mondo che guadagnano terreno nel mercato del vino investibile, il Cabernet di Thelema
                        I Sauvignon (in particolare lo straordinario 2015) sono considerati investimenti di prim'ordine tra quelli in
                        il sapere. Il lungo invecchiamento e il prezzo basso (si pensi ai 20-25 euro in Europa a bottiglia) hanno sedotto il mercato
                        investitori. Ma attenzione: il 2015 ha mostrato un forte aumento dei prezzi di quasi il 60% in meno di
                        12 mesi dall'agosto 2018, quindi sembra che non siamo gli unici che Thelema sta tentando.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Thelema Mountain Vineyards</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Da die Weine aus der Neuen Welt auf dem Vormarsch sind, geraten viele Witwen der Region möglicherweise in Vergessenheit.
                        Warum sollten Sie zum Beispiel einen Kanonkop in Betracht ziehen, wenn Sie doch eine sexy kleine Eben-Sadie-Nummer haben?
                        Wartest du zu Hause auf dich? Aber es wäre ein Fehler, die Oldies zu ignorieren (die, relativ
                        Im Vergleich zu manchen europäischen Dinosauriern sind sie, wenn man sie genauer betrachtet, nur Kinder in Waffen. Thelema-Berg
                        Weinberge, gepflanzt im Jahr 1983, ist ein solcher Oldie, der nicht im hinteren Regal gelassen werden sollte.
                    </div>

                    <div class="howto-title2">Vom Rechner zu den Feldern</div>
                    <div class="howto-text">
                        Als Gyles Webb, ein Buchhalter aus Durban, 1983 einen Burgunder Puligny-Montrachet trank, hatte er eine Offenbarung. Er ließ sich zum Önologen umschulen, kaufte eine heruntergekommene alte 157 Hektar große Obstfarm, riss die Obstgärten ab und pflanzte Weinreben. Die Restaurierung des Herrenhauses dauerte fünf Jahre, also konzentrierte er sich darauf, während die Trauben reiften, und 1988 wurde der erste Wein unter dem Label Thelema auf den Markt gebracht. Die frischen, fruchtigen Weine waren nicht nur führend in der Weinbewegung der neuen Welt, sondern auch eine Offenbarung für viele (in gewissem Maße auch für Webb selbst). Es dauerte nicht lange, bis die romantische Geschichte einer heruntergekommenen alten Obstfarm zur Erfolgsgeschichte eines modernen Weinguts wurde. In den späten 1990er Jahren war Thelema der Wein des Tages unter der Elite Südafrikas.
                        <br><br>
                        Obwohl Webb als eine Art Weinbau-Visionär gilt, übergab er im Jahr 2000 die Leitung
                        Er übergab die Leitung des Weinbaus an den talentierten Rudi Schultz und übernahm die Rolle des Kellermeisters. In 2002,
                        Webb weitete seinen Betrieb auf die Küstenregion Elgin mit kühlem Klima aus, wo sich das Weingut befand
                        produziert seine Sutherland-Weinlinie.
                    </div>

                    <div class="howto-title2">Der Cab Sav-König von Stellenbosch</div>
                    <div class="howto-text">
                        Da alle Weine der neuen Welt auf dem Markt für investierbare Weine an Bedeutung gewinnen, ist Thelemas Cabernet
                        Sauvignons (insbesondere der umwerfende 2015) gelten unter denen als Blue-Chip-Investitionen
                        das Wissen. Lange Reifung und niedrige Preise (denken Sie an 20–25 € für eine Flasche in Europa) haben den Markt verführt
                        Investoren. Aber aufgepasst – das Jahr 2015 verzeichnete in weniger als einem Jahr einen starken Preisanstieg von fast 60 %
                        12 Monate seit August 2018, es sieht also so aus, als wären wir nicht die Einzigen, die Thelema in Versuchung führt.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Vignobles de Thelema Mountain</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Avec l'essor des vins du nouveau monde, de nombreuses douairières de la région peuvent être oubliées.
                        Pourquoi, par exemple, envisageriez-vous un Kanonkop, alors que vous avez un petit numéro sexy d'Eben Sadie
                        vous attend à la maison? Mais vous auriez tort d'ignorer les anciens (qui, relativement
                        parlant, ne sont que des bébés dans les bras comparés à certains des dinosaures européens). Montagne de Thélème
                        vignobles, plantés en 1983, est un de ces anciens qu'il ne faut pas laisser de côté.
                    </div>

                    <div class="howto-title2">De la calculatrice aux champs</div>
                    <div class="howto-text">
                        En buvant un Bourgogne Puligny-Montrachet en 1983, Gyles Webb, un comptable de Durban, a eu une épiphanie. Il se reconvertit en œnologue, rachète une ancienne exploitation fruitière délabrée de 157 hectares, arrache les vergers et plante des vignes. La restauration du manoir a pris cinq ans, alors il s'est concentré sur cela pendant que les raisins mûrissaient, et en 1988, le premier vin sous l'étiquette Thelema a été lancé. Les vins frais et fruités n'étaient pas seulement des leaders dans le nouveau mouvement mondial du vin, mais aussi une révélation pour beaucoup (y compris dans une certaine mesure Webb lui-même). Il ne fallut pas longtemps avant que l'histoire romantique d'une ancienne ferme fruitière délabrée devienne l'histoire à succès d'une cave moderne. À la fin des années 1990, Thelema était le vin du jour parmi l'élite sud-africaine.
                        <br><br>
                        Bien que Webb soit considéré comme un visionnaire de la viticulture, en 2000, il a passé les rênes
                        de la vinification au talentueux Rudi Schultz et est passé au rôle de maître de chai. En 2002,
                        Webb a étendu ses activités à la région côtière au climat frais d'Elgin, où la cave
                        produit sa gamme de vins Sutherland.
                    </div>

                    <div class="howto-title2">Le roi des taxis sav de Stellenbosch</div>
                    <div class="howto-text">
                        Alors que tous les vins du nouveau monde gagnent du terrain sur le marché du vin investissable, Thelema’s Cabernet
                        Les sauvignons (en particulier le superbe 2015) sont considérés comme des investissements de premier ordre parmi ceux de
                        le savoir. Le long vieillissement et la sous-tarification (pensez 20-25 € en Europe pour une bouteille) ont séduit le marché
                        investisseurs. Mais attention - le 2015 a montré une forte hausse des prix de près de 60% en moins de
                        12 mois depuis août 2018, il semble donc que nous ne soyons pas les seuls à tenter Thelema.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Thelema Mountain Vineyards</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        With new world wines on the rise, many of the dowagers of the region can get forgotten about.
                        Why, for example, would you consider a Kanonkop, when you have a sexy little Eben Sadie number
                        waiting for you back home? But you would be mistaken to ignore the oldies (which, relatively
                        speaking, are just babes in arms compared to some of the European dinosaurs). Thelema Mountain
                        vineyards, planted in 1983, is one such oldie that should not left to the back shelf.
                    </div>

                    <div class="howto-title2">From the calculator to the fields</div>
                    <div class="howto-text">
                        Upon drinking a Burgundy Puligny-Montrachet in 1983, Gyles Webb, an accountant from Durban, had an epiphany. He retrained as an oenologist, bought a decrepit old 157-hectare fruit farm, ripped out the orchards and planted vines. Restoration of the manor took five years so he concentrated on that while the grapes were maturing, and in 1988 the first wine under the label Thelema was released. The fresh, fruity, wines were not only leaders in the new world wine movement but also a revelation to many (including to a certain extent Webb himself). It wasn’t long before the romantic tale of a run-down old fruit farm became the success story of a modern winery. By the late 1990s, Thelema was the wine du jour among South Africa’s elite.
                        <br><br>
                        Despite Webb being considered something of a winemaking visionary, in 2000, he handed the reins
                        of winemaking to the talented Rudi Schultz and moved into the role of cellar master. In 2002,
                        Webb expanded his operation to the cool climate coastal region of Elgin where the winery
                        produces its Sutherland line of wines.
                    </div>

                    <div class="howto-title2">The Cab Sav king of Stellenbosch</div>
                    <div class="howto-text">
                        With all new world wines gaining traction in the investable wine market, Thelema’s Cabernet
                        Sauvignons (particular the stunning 2015) are considered blue-chip investments among those in
                        the know. Long-ageing and underpricing (think €20-25 in Europe for a bottle) have seduced market
                        investors. But watch out - the 2015 has shown a sharp price hike of almost 60% in less than
                        12-months since August 2018, so it looks like we are not the only ones whom Thelema is tempting.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ThelemaMountainVineyards",
    data() {
        return {
            select: {
                report: 'Thelema Mountain Vineyards',
                src: '/wine-guide/south-africa/stellenbosch/thelema-mountain-vineyards'
            },
            items: [
                {report: 'Alto Wine Estate', src: '/wine-guide/south-africa/stellenbosch/alto-wine-estate'},
                {report: 'Kanonkop Paul Sauer', src: '/wine-guide/south-africa/stellenbosch/kanonkop-paul-sauer'},
                {report: 'Meerlust Estate', src: '/wine-guide/south-africa/stellenbosch/meerlust-estate'},
                {report: 'Savanha Wines', src: '/wine-guide/south-africa/stellenbosch/savanha-wines'},
                {report: 'The Sadie Family Wines', src: '/wine-guide/south-africa/stellenbosch/the-sadie-family-wines'},
                {
                    report: 'Thelema Mountain Vineyards',
                    src: '/wine-guide/south-africa/stellenbosch/thelema-mountain-vineyards'
                }
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Thelema Mountain Vineyards | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional wines of Thelema Mountain Vineyards, a renowned producer in the heart of the Stellenbosch wine region. Experience the unique blend of Old World techniques and New World innovation in every bottle, crafted with passion and dedication to produce truly outstanding wines. Visit our vineyards today and taste the magic for yourself.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}
.wine-guide-body {
    padding-top: 35px;
}
.wine-guide-left {
    width: 300px;
    display: inline-block;
}
.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}
.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}
.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}
.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
